import { PWA_SW_PATH } from "./config";

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return null;
  }

  if (process.env.NODE_ENV !== "production") {
    return null;
  }

  try {
    return await navigator.serviceWorker.register(PWA_SW_PATH, { scope: "/" });
  } catch {
    return null;
  }
}

export function postSkipWaiting(worker: ServiceWorker | null | undefined): void {
  worker?.postMessage({ type: "SKIP_WAITING" });
}
